import { Component, Input, OnInit, Injector } from '@angular/core';
import { Observable, combineLatest } from 'rxjs';
import { map, mergeMap, tap,merge, debounceTime, filter } from 'rxjs/operators';
import {
  LoggedComponent,
  LoggerService,
  SeriesStageLocator,
  SeriesStagesItem,
  ViewDataInterface,
  ViewDataService
} from 'world-archery-lib';
import { FiltersServiceService } from '../filters-service.service';
import { TableAbstractComponent } from '../../../common-page-components/classes/table-abstract-component';
import { SeriesStageIndoorStore, ISeriesStageIndoor } from '../../../common-page-components/stores/entities-store/series-stage-indoor-store';

@Component({
  selector: 'app-event-list-indoor',
  templateUrl: './event-list-indoor.component.html',
  styleUrls: ['./event-list-indoor.component.css']
})
export class EventListIndoorComponent extends TableAbstractComponent
  implements OnInit {
  eventList: {} = {};
  constructor(
    injector:Injector,
    public filter_service: FiltersServiceService
  ) {
    super(injector, filter_service, new SeriesStageIndoorStore(injector));
  }


  ngOnInit() {
    const groupDate = (data, keyFn) =>
      data.reduce((agg, item) => {
        const group = keyFn(item);
        agg[group] = [...(agg[group] || []), item];
        return agg;
      }, {});
    this.getDataStream()
      .pipe(
        map(a=> (a as any).items),
        map((data: Array<any>) =>
          data.sort((a, b) => {

            return a.dateFrom > b.dateFrom ? +1 : -1;
          })
        ),
        map((data:Array<ISeriesStageIndoor>) =>
          groupDate(data, (item:ISeriesStageIndoor) => {
            // Now we group by year-month group.
            const date = new Date();
            date.setFullYear(item.DFrom.split('-')[0] as any);
            date.setMonth(Number(item.DTo.split('-')[1]) - 1 as any);
            return date;
          })
        ),
        tap(a=>Object.keys(a).forEach(key=> a[key].reverse() ))
      )
      .subscribe(next => {
        this.eventList = next;
      });
  }

  objectKeys(): string[] {
    return Object.keys(this.eventList).reverse();
  }
  getDataStream(): Observable<Array<any>> {
    return combineLatest(
      this.reload.asObservable(),
      this.filter_service.yearCombo.comboData,
      this.filter_service.textFilter.data(300),
    ).pipe(
      map(([reload, year, text]) => {
        const params = {
          Year: year ? year.Year : undefined,
          fText: text.text,
          DisciplineId: 2
        };
        return params;
      }),
      mergeMap(params => {
        return this.model.requestData(params, this.request_more_data);
      })
    );

  }

  parseDate(dateGrouped: string): Date {
    return new Date(dateGrouped);
  }

}
